module.exports = __webpack_public_path__ + "static/img/erweima.2223636.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/hardProduct/images/erweima.jpg
// module id = w7sC
// module chunks = 1